import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CustomAccordionProps {
  panelKey: string;
  title: any;
  subtitle?: string;
  expanded: string | false;
  onChange: (
    panel: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  children: React.ReactNode;
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  panelKey,
  title,
  subtitle,
  expanded,
  onChange,
  children,
}) => {
  return (
    <Accordion expanded={expanded === panelKey} onChange={onChange(panelKey)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${panelKey}-content`}
        id={`${panelKey}-header`}
      >
        <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography component="span" sx={{ color: "text.secondary" }}>
            {subtitle}
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
